import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=8fb47a20"
import script from "./photoList.vue?vue&type=script&lang=js"
export * from "./photoList.vue?vue&type=script&lang=js"
import style0 from "./photoList.vue?vue&type=style&index=0&id=8fb47a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports